<template>
  <v-card>
    <v-card-title>グラフ出力の対応</v-card-title>
    <v-card-text>
      <v-container>
        <v-form ref="form" v-model="valid">
          <!-- {{ value }} -->
          {{ desc }}
          <v-row class="mt-4">
            <v-col cols="4">
              <v-radio-group label="一覧表の表示" v-model="desc[0]" row>
                <v-radio label="有" v-bind:value="'true'"></v-radio>
                <v-radio label="無" v-bind:value="'false'"></v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="4">
              <v-text-field label="特殊関数" v-model="desc[1]"></v-text-field>
            </v-col>
          </v-row>

          <hr />
          <!------------------------------------------------>
          <v-col>
            <h3>計算対象</h3>
            <div v-for="(count, i) in counting" :key="i" class="mb-4">
              <v-row rows="12">
                <v-col cols="3">
                  <v-text-field
                    label="表示名"
                    v-model="count.Label"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    label="フォームID"
                    v-model.number="count.formID"
                    required
                    :rules="[validation.numonly]"
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>
          </v-col>
          <v-row>
            <v-btn
              color="success"
              @click="delCount"
              :disabled="counting.length < 2"
              class="ma-2"
              >削除</v-btn
            >
            <v-btn
              color="success"
              @click="addCount"
              :disabled="counting.length > 0"
              class="ma-2"
              >追加</v-btn
            >
          </v-row>
          <hr />
          <!-- ---------------------------------------------------------------------->
          <h3>グルーピング項目の選択肢</h3>
          <div v-for="(group, i) in grouping" :key="i" class="mb-4">
            <v-row rows="12">
              <v-col cols="3">
                <v-text-field
                  label="表示名"
                  v-model="group.Label"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  label="フォームID"
                  v-model.number="group.formID"
                  required
                  :rules="[validation.numonly]"
                ></v-text-field>
              </v-col>
            </v-row>
          </div>
          <v-row>
            <v-btn
              color="success"
              @click="delGroup"
              :disabled="grouping.length < 2"
              class="ma-2"
              >削除</v-btn
            >
            <v-btn color="success" @click="addGroup" class="ma-2">追加</v-btn>
          </v-row>
        </v-form>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn :color="returnData.color" @click="submit">OK</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
//import { RepositoryFactory } from "../../../api/RepositoryFactory";
//const api = RepositoryFactory.get("api2");

export default {
  components: {},
  props: {
    page_id: Number,
    data: Object,
    description: String,
  },
  data() {
    return {
      returnData: {
        name: "graph",
        data: this.data,
        //description: this.description,
      },
      //
      desc: ["false", "test"],
      //
      counting: [], //カウント対象
      grouping: [], //グループイング対象
      graph: [
        { label: "棒グラフ", value: "bar" },
        { label: "円グラフ", value: "cycle" },
      ],
      //バリデーション
      valid: true,
      validation: {
        numonly: (value) => {
          return /^[0-9]*$/.test(value) || "数値のみ";
        },
      },
    };
  },
  async mounted() {
    //初期処理
    await this.getInit();
  },
  methods: {
    async getInit() {
      //
      this.grouping = this.data.value;
      this.counting = this.data.rule;
      this.desc = this.description.split(",");
    },
    //--------------------------------------------------
    addGroup() {
      this.grouping.push({ formID: 0, Label: "ラベル" });
    },
    delGroup() {
      if (this.grouping.length > 1) {
        this.grouping.splice(-1, 1);
      }
    },
    addCount() {
      this.counting.push({ formID: 0, Label: "ラベル" });
    },
    delCount() {
      if (this.counting.length > 1) {
        this.counting.splice(-1, 1);
      }
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.returnData.data.grouping = this.grouping;
        this.returnData.data.counting = this.counting;
        this.returnData.data.description = this.desc.join(",");
        this.$emit("clickSubmit", this.returnData);
      }
    },
  },
};
</script>
